// extracted by mini-css-extract-plugin
module.exports = {"base":"SmallELogo-module-base"};